import React from "react";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <div className="footer f-14">
      <br />
      <div className="cpp-divider mb-2"></div>
      <div className="f-sem-bol">
        &#169; 2019 - {currentYear}
        <a
          href="https://incruiter.com"
          target="_blank"
          rel="noreferrer"
          className="footer-text m-2 f-bol footer-link"
        >
          InCruiter
        </a>
      </div>
    </div>
  );
};

export default Footer;
